module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-92d99047.png";